import { useRef, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export const ImageUpload = ({ value, onChange, label, testid, aspect = "square" }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.path);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {label && <label className="text-xs font-medium uppercase tracking-wider text-slate-400">{label}</label>}
      <div className="mt-1.5 flex items-center gap-4">
        <div className={`relative overflow-hidden rounded-xl bg-slate-800 border border-slate-700 grid place-items-center ${aspect === "wide" ? "w-40 h-24" : "w-24 h-24"}`}>
          {value ? (
            <>
              <img src={fileUrl(value)} alt="preview" className="w-full h-full object-cover" />
              <button
                type="button"
                data-testid={`${testid}-remove`}
                onClick={() => onChange(null)}
                className="absolute top-1 right-1 bg-black/60 hover:bg-black/80 rounded-full p-1"
              >
                <X className="h-3 w-3 text-white" />
              </button>
            </>
          ) : (
            <Upload className="h-6 w-6 text-slate-500" />
          )}
        </div>
        <button
          type="button"
          data-testid={testid}
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          className="inline-flex items-center gap-2 bg-slate-800 hover:bg-slate-700 border border-slate-700 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {value ? "Replace" : "Upload"}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </div>
  );
};
